__webpack_require__.p = "/project_friday/";